import { useFileUpload, UseFileUploadOpts } from '@thesisedu/feature-attachments-react'

export function useLexicalUpload(namespace: string, opts: UseFileUploadOpts = {}) {
  return useFileUpload({
    namespace: `generic-attachments/widgets/${namespace}`,
    ...opts,
  })
}
